import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "24",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22 21.8V19.8C22 17.9362 20.7252 16.3701 19 15.9261M15.5 4.09081C16.9659 4.68419 18 6.12136 18 7.80005C18 9.47874 16.9659 10.9159 15.5 11.5093M17 21.8C17 19.9363 17 19.0044 16.6955 18.2693C16.2895 17.2892 15.5108 16.5105 14.5307 16.1045C13.7956 15.8 12.8638 15.8 11 15.8H8C6.13623 15.8 5.20435 15.8 4.46927 16.1045C3.48915 16.5105 2.71046 17.2892 2.30448 18.2693C2 19.0044 2 19.9363 2 21.8M13.5 7.80005C13.5 10.0092 11.7091 11.8 9.5 11.8C7.29086 11.8 5.5 10.0092 5.5 7.80005C5.5 5.59091 7.29086 3.80005 9.5 3.80005C11.7091 3.80005 13.5 5.59091 13.5 7.80005Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }